const { inRange, range, isEmpty, } = require('lodash');
const { format: formatDate, } = require('date-fns');

const { optionLabel, } = require('../lib/consolidationAccountItems');

const { entries } = Object;
const inheritTypes = {
  none: { label: 'なし', },
  carry: { label: '繰越', },
  reversal: { label: '洗替', },
};

const batchCloneFields = ({ company, periodOptions, fiscalYearOfPeriod, }) => {
  return {
    period: {
      label: '事業年度',
      type: 'select',
      options: periodOptions,
      validations: {
        required: v => v != null,
      },
    },
    yearMonth: {
      label: '月度',
      type: 'select',
      options: (state) => {
        const fiscalYear = fiscalYearOfPeriod(state.period, company.fiscalYears) || {};
        const { start_date: startDate, end_date: endDate } = fiscalYear;
        const monthOptions = startDate ? range(formatDate(new Date(startDate), 'yyyyMM'), formatDate(new Date(endDate), 'yyyyMM') + '.1').filter(_ => inRange(parseInt(_.toString().slice(-2), 10), 1, 12.1)).map(_ => ({ label: `${_.toString().slice(0, 4)}/${_.toString().slice(4)}`, value: _.toString() })) : [];
        return monthOptions;
      },
      validations: {
        required: v => v != null,
      },
    },
  };
};

const fields = () => {
  return {
    inheritType: {
      label: '翌期への引き継ぎ',
      type: 'select',
      options: entries(inheritTypes).map(([k, v]) => ({ label: v.label, value: k })),
      initialValue: 'none',
      validations: {
        required: v => v != null,
      },
    },
    description: {
      label: '説明',
      type: 'text',
    }
  };
};

const itemFields = ({ consolidationAccountItems = [], sections = [], relatedCompany, customChangeFields = [], ordersByModelType = {}, keptChangeTypes = [], }) => {
  const { currency = 'jpy' } = relatedCompany;
  const { buildChangeTypeOptions, } = require('../changeTypes');
  const changeTypeOptions = buildChangeTypeOptions(customChangeFields, ordersByModelType, keptChangeTypes);
  return {
    debitItemId: {
      label: '借方科目',
      type: 'select',
      options: consolidationAccountItems.map(_ => ({ label: optionLabel(_), value: _.id })),
      validations: {
        requiredInSomeCase: (v, s) => !(Math.abs(s.debitAmount) > 0 && isEmpty(v)),
      },
    },
    debitSectionId: {
      label: '借方部門',
      type: 'select',
      options: sections.map(_ => ({ label: _.name, value: _.id })),
    },
    debitAmount: {
      label: '借方金額',
      type: currency === 'jpy' ? 'integer' : 'float',
    },
    debitChangeType: {
      label: '借方増減種別',
      type: 'select',
      options: changeTypeOptions,
    },
    creditItemId: {
      label: '貸方科目',
      type: 'select',
      options: consolidationAccountItems.map(_ => ({ label: optionLabel(_), value: _.id })),
      validations: {
        requiredInSomeCase: (v, s) => !(Math.abs(s.creditAmount) > 0 && isEmpty(v)),
      },
    },
    creditSectionId: {
      label: '貸方部門',
      type: 'select',
      options: sections.map(_ => ({ label: _.name, value: _.id })),
    },
    creditAmount: {
      label: '貸方金額',
      type: currency === 'jpy' ? 'integer' : 'float',
    },
    creditChangeType: {
      label: '貸方増減種別',
      type: 'select',
      options: changeTypeOptions,
    },
  };
};

exports.itemFields = itemFields;
exports.fields = fields;
exports.batchCloneFields = batchCloneFields;
exports.inheritTypes = inheritTypes;
